import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../../environments/environment';
import { ApiMethodService } from '../../../../tools/services/api/method-api/apiMethod.service';
import { ActionBackOfficeResponse } from '../../../models/api.model';
import {
  ParkingSitePayload,
  ParkingSiteTableDto,
  ParkingSiteTableQuery,
  ParkingSiteTableResponse,
} from '../../../models/parking/parking-site.model';

@Injectable({
  providedIn: 'root',
})
export class ApiParkingSiteService {
  private readonly baseUrl = environment.apiPrivateUrl;
  private readonly cookieService = inject(CookieService);
  private readonly apiMethodService = inject(ApiMethodService);

  getParkingSiteForTable(query: ParkingSiteTableQuery = {}): Observable<ParkingSiteTableResponse> {
    const token = this.cookieService.get('token');
    const userIdStr = this.cookieService.get('user_id');
    const userId = userIdStr ? parseInt(userIdStr, 10) : 0;

    const params: Record<string, string | number> = {
      userId,
      page: query.page ?? 1,
      pageSize: query.pageSize ?? 20,
    };

    if (query.searchField) params['searchField'] = query.searchField;
    if (query.searchText) params['searchText'] = query.searchText;
    if (query.sortColumn) params['sortColumn'] = query.sortColumn;
    if (query.sortDirection) params['sortDirection'] = query.sortDirection;

    return this.apiMethodService.request<ParkingSiteTableResponse>(
      '/backoffice/getParkingSiteForTable',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getParkingSiteForTable',
        token,
        headerOnly: false,
        params,
      }
    );
  }

  getParkingSiteById(id: number): Observable<ParkingSiteTableDto> {
    const token = this.cookieService.get('token');
    const userIdStr = this.cookieService.get('user_id');
    const userId = userIdStr ? parseInt(userIdStr, 10) : 0;

    return this.apiMethodService.request<ParkingSiteTableDto>(
      '/backoffice/getParkingSiteById',
      'GET',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'getParkingSiteById',
        token,
        headerOnly: false,
        params: { id, userId },
      }
    );
  }

  insertParkingSite(payload: ParkingSitePayload): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      '/backoffice/insertParkingSite',
      'POST',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'insertParkingSite',
        token,
        headerOnly: false,
        body: payload,
      }
    );
  }

  updateParkingSite(payload: ParkingSitePayload, id: number): Observable<ActionBackOfficeResponse> {
    const token = this.cookieService.get('token');
    return this.apiMethodService.request<ActionBackOfficeResponse>(
      `/backoffice/updateParkingSite/${id}`,
      'PATCH',
      this.baseUrl,
      {
        isConsoleLog: true,
        labelLog: 'updateParkingSite',
        token,
        headerOnly: false,
        body: payload,
      }
    );
  }
}
